import { getDataFromScript } from "../utils/helpers";

export default class CatalogsSearch {
  constructor() {
    this.searchBar = document.getElementById('search-bar');
    this.table = document.getElementById('grid_catalogs');
    if (this.searchBar && this.table) {
      this.catalogs = getDataFromScript('catalogs-table-data') || null;
      this.rows = this.table.querySelectorAll('tbody tr');
      this.searchInput = this.searchBar.querySelector('#search-input');

      this.initSearch()
    }
  }

  initSearch() {
    this.rows.forEach(( tr, key ) => {
      if (!tr.classList.contains('no-data-row')) {
        tr.setAttribute('data-catalogs-id', this.catalogs[key].id);
      }
    });

    this.searchInput.addEventListener('keyup', this.filterDataTable.bind(this));
  }

  filterByName = (catalogs, value) => catalogs.filter( c => {
    const name = c.name.toUpperCase(),
    filter = value.toUpperCase();

    return name.indexOf( filter ) > -1 || !value;
  });

  filterDataTable() {
    let catalogsFiltered = this.catalogs;
    catalogsFiltered = this.filterByName(catalogsFiltered, this.searchInput.value);
    const idsToShow = catalogsFiltered.map( c => c.id );

    this.rows.forEach(( tr ) => {
      if (tr.hasAttribute('data-catalogs-id') && idsToShow.indexOf(tr.getAttribute('data-catalogs-id')) === -1) {
        tr.classList.add('d-none');
      } else {
        tr.classList.remove('d-none');
      }
    });
  }
}
